import {
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
} from '@/components/common/Buttons';

import type {
  ButtonLink,
  ButtonProps,
} from '@/components/common/Buttons/shared';

export const renderButton = (buttonVariant, props) => {
  switch (buttonVariant) {
    case 'secondary':
      return <SecondaryButton {...props} />;
    case 'tertiary':
      return <TertiaryButton {...props} />;
    default:
      return <PrimaryButton {...props} />;
  }
};

export const isAnchor = (props: ButtonProps): props is ButtonLink => {
  return 'href' in props;
};
